import { environment } from '@root/environments/environment';

export const isWindowsEnvironment = !JSON.parse(
  environment.loginOnBehalfEnabled
);
